import { Component, input } from '@angular/core';

import { NgClass } from '@angular/common';

import { IconAppleStoreComponent } from '../../../shared/components/icon-apple-store/icon-apple-store.component';
import { IconGooglePlayComponent } from '../../../shared/components/icon-google-play/icon-google-play.component';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { AuthEventType } from '../../../../enums/event/event.enum';
import { LinkClick } from '../../../../models/event-data.model';

@Component({
  selector: 'app-app-store-links',
  standalone: true,
  imports: [IconAppleStoreComponent, IconGooglePlayComponent, NgClass],
  templateUrl: './app-store-links.component.html',
  styleUrl: './app-store-links.component.scss',
})
export class AppStoreLinksComponent {
  isDarkMode = input<boolean>(false);
  isFooter = input<boolean>(false);

  constructor(private readonly eventTrackingService: EventTrackingService) {}

  getCustomerPortalClickLinkType(): string {
    return this.isFooter() ? 'mobileAppFooter' : 'mobileAppPlacement';
  }
  fireGooglePlayEvent() {
    this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
      authClickLinkText: 'Get it on Google Play',
      authClickLinkType: this.getCustomerPortalClickLinkType(),
    });
  }
  fireAppStoreEvent() {
    this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
      authClickLinkText: 'Download on the App Store',
      authClickLinkType: this.getCustomerPortalClickLinkType(),
    });
  }
}
